/**
 *
 * Loader
 *
 */

import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';

import styled from 'styled-components';
import { Card } from '../Card';

import './style.scss';

const Container = styled.div``;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

/* eslint-disable react/prefer-stateless-function */
export class Loader extends React.PureComponent {
  render() {
    if (this.props.size == 'small' || this.props.small) return <FontAwesomeIcon icon={faSpinner} pulse size="1x" />;

    let loader = (
      <Content className="loader">
        <div className="iconContainer">
          <FontAwesomeIcon icon={faSpinner} pulse size="2x" />
        </div>
        <div className="label">{this.props.label || ''}</div>
      </Content>
    );

    if (this.props.onCard) {
      loader = <Card>{loader}</Card>;
    }

    if (this.props.fullPage) {
      return <Container>{loader}</Container>;
    }

    return loader;
  }
}

Loader.propTypes = {
  fullPage: PropTypes.bool,
  onCard: PropTypes.bool,
  size: PropTypes.string,
};
